var _style, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHxCl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bandera",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.4 453.2",
    style: {
      enableBackground: "new 0 0 511.4 453.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000109715300108126318540000001336167383110534551_);fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_00000109715300108126318540000001336167383110534551_);fill:#313F98;}\n\t.st2{clip-path:url(#SVGID_00000109715300108126318540000001336167383110534551_);fill:#C22727;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.4,0H149c-15.1,0-29.1,8.1-36.7,21.2L5.7,205.4c-7.6,13.1-7.6,29.4,0,42.5l106.6,184.2c7.6,13.1,21.6,21.2,36.7,21.2 h213.4c15.1,0,29.1-8.1,36.7-21.2l106.6-184.2c7.6-13.1,7.6-29.4,0-42.5L399.1,21.2C391.5,8.1,377.5,0,362.4,0z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M118.3,432.8L8.4,242.5c-5.7-9.8-5.7-22,0-31.8L118.3,20.4c5.7-9.8,16.2-15.9,27.6-15.9h219.7 c11.4,0,21.9,6.1,27.5,15.9L503,210.7c5.7,9.8,5.7,22,0,31.8L393.1,432.8c-5.7,9.8-16.2,15.9-27.5,15.9H145.9 C134.5,448.7,124,442.7,118.3,432.8L118.3,432.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021106965881929566380000012989687914885590716_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 224.4,
    style: {
      clipPath: "url(#SVGID_00000021106965881929566380000012989687914885590716_)",
      fill: "#FFFFFF"
    },
    width: 287,
    height: 228.9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000021106965881929566380000012989687914885590716_)",
      fill: "#313F98"
    },
    width: 224.4,
    height: 228.9
  }), /*#__PURE__*/React.createElement("rect", {
    y: 228.9,
    style: {
      clipPath: "url(#SVGID_00000021106965881929566380000012989687914885590716_)",
      fill: "#C22727"
    },
    width: 511.4,
    height: 224.4
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000021106965881929566380000012989687914885590716_)",
      fill: "#FFFFFF"
    },
    points: "152.2,123.3  185.1,99.3 144.4,99.3 131.8,60.6 119.2,99.3 78.4,99.3 111.4,123.3 98.8,162 131.8,138.1 164.7,162  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHxCl);
export default __webpack_public_path__ + "static/media/hx-cl.4ddbf220fc79582d9fef7f73fef81c0d.svg";
export { ForwardRef as ReactComponent };